// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__3vMjS","right":"styles_right__2upXP"};